import React, { useState, useEffect } from "react";
import { CloudUpload, X } from "lucide-react";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
// import { useApiCall } from "../custom-hooks/api-call";

const T = {
  bg: '#EDE8E1',
  sidebar: '#1a1730',
  sidebarHover: '#252240',
  sidebarActive: '#302d4a',
  card: '#FFFFFF',
  cardBorder: 'rgba(0,0,0,0.08)',
  text: '#1a1520',
  textSecondary: '#5c5466',
  textMuted: '#908892',
  accent: '#6366f1',
  accentLight: 'rgba(99,102,241,0.08)',
  accentText: '#5457e5',
  shadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)',
  shadowLg: '0 8px 30px rgba(0,0,0,0.08)',
  inputBg: '#F3EFE9',
  inputBorder: 'rgba(0,0,0,0.1)',
};

const Card = ({ children, style = {}, hover = false, onClick }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => hover && setHovered(true)}
      onMouseLeave={() => hover && setHovered(false)}
      style={{
        background: T.card, border: `1px solid ${T.cardBorder}`, borderRadius: 12,
        boxShadow: hovered ? T.shadowMd : T.shadow,
        transform: hovered ? 'translateY(-1px)' : 'none',
        transition: 'all 0.15s ease', cursor: onClick ? 'pointer' : 'default', ...style,
      }}
    >{children}</div>
  );
};

const Icon = ({ name, size = 16, color = 'currentColor' }) => {
  const p = { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" };
  const map = {
    phone: <svg {...p}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
    mail: <svg {...p}><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>,
    sms: <svg {...p}><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22z"/></svg>,
    calendar: <svg {...p}><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>,
    clock: <svg {...p}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>,
    edit: <svg {...p}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
    arrowRight: <svg {...p}><path d="M5 12h14M12 5l7 7-7 7"/></svg>,
    check: <svg {...p}><path d="M20 6 9 17l-5-5"/></svg>,
    star: <svg {...p}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill={color} stroke={color}/></svg>,
    file: <svg {...p}><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/></svg>,
    note: <svg {...p}><path d="M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
    user: <svg {...p}><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
    dollar: <svg {...p}><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
    target: <svg {...p}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
    zap: <svg {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
    link: <svg {...p}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>,
    globe: <svg {...p}><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
    x: <svg {...p}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
    chevDown: <svg {...p}><polyline points="6 9 12 15 18 9"/></svg>,
    chevRight: <svg {...p}><polyline points="9 18 15 12 9 6"/></svg>,
    copy: <svg {...p}><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>,
    send: <svg {...p}><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
    play: <svg {...p}><polygon points="5 3 19 12 5 21 5 3" fill={color}/></svg>,
    mic: <svg {...p}><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/></svg>,
    plus: <svg {...p}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
    refresh: <svg {...p}><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>,
    package: <svg {...p}><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
    hash: <svg {...p}><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></svg>,
    flag: <svg {...p}><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>,
    eye: <svg {...p}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
    trendUp: <svg {...p}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
    shield: <svg {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
    alertCircle: <svg {...p}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  };
  return map[name] || null;
};

const FilesTab = ({ leadId, attachmenttype ,data = {},updateCount = () => {}}) => {
  const apiCall = useApiCall();

  const [pendingUploads, setPendingUploads] = useState([]); 
  const [uploaded, setUploaded] = useState([]); 
  const [isConfirming, setIsConfirming] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

 
  const fetchAttachments = async () => {
    try {
      setIsLoading(true);
      const res = await apiCall({
        method: "post",
        url: "attachments/get-attachments",
        data: {
          attachable_id: leadId,
          attachable_type: attachmenttype,
        },
      });
      if (res?.status && Array.isArray(res.data)) {
        setUploaded(res.data);
      }

      updateCount(
          {
            ...data,
            attachments_count: res?.data?.length ,
          }
        );
    } catch (err) {
      console.error("Fetch attachments error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (leadId) fetchAttachments();
  }, [leadId]);

 
  const handleFileChange = async (e) => {
    const newFiles = Array.from(e.target.files);
    if (!newFiles.length) return;

    const formData = new FormData();
    newFiles.forEach((f) => formData.append("files[]", f));

    try {
      const uploadRes = await apiCall({
        method: "post",
        url: "attachments/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes?.data?.length) {
        setPendingUploads((prev) => [...uploadRes.data, ...prev]);
      }
    } catch (err) {
      console.error("Upload error:", err);
    } finally {
      e.target.value = ""; // reset file input
    }
  };

  // Handle drag & drop upload
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };
  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    if (!droppedFiles.length) return;

    const formData = new FormData();
    droppedFiles.forEach((f) => formData.append("files[]", f));

    try {
      const uploadRes = await apiCall({
        method: "post",
        url: "attachments/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes?.data?.length) {
        setPendingUploads((prev) => [...uploadRes.data, ...prev]);
      }
    } catch (err) {
      console.error("Upload error:", err);
    }
  };

  // Delete pending unconfirmed upload
  const removePendingUpload = async (id) => {
    try {
      await apiCall({
        method: "post",
        url: `attachments/delete-unconfirmed-attachment/${id}`,
      });
      setPendingUploads((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error("Failed to delete unconfirmed file:", err);
    }
  };

  // Confirm all pending uploads
  const handleConfirmPending = async () => {
    if (!pendingUploads.length) return;
    setIsConfirming(true);
    try {
      const ids = pendingUploads.map((p) => p.id);
      const res = await apiCall({
        method: "post",
        url: "attachments/confirm",
        data: {
          attachment_ids: ids,
          attachable_type: attachmenttype,
          attachable_id: leadId,
        },
      });

      // Move pending to uploaded
      setUploaded((prev) => [...pendingUploads, ...prev]);
      setPendingUploads([]);
      fetchAttachments()
    } catch (err) {
      console.error("Confirm error:", err);
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <div className="space-y-4">
      {/* Upload Box */}
      
        <Card style={{ padding: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, border: `2px dashed ${T.accent}30` }}
                
                onClick={() => document.getElementById("fileInput").click()}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
                >


        <Icon name="plus" size={24} color={T.accent} />
                  <span style={{ fontSize: 13, color: T.accentText, fontWeight: 600 }}>Drop files here or click to upload</span>
                  <span style={{ fontSize: 11, color: T.textMuted }}>Contracts, proposals, brand assets</span>

        <input
          type="file"
          multiple
          onChange={handleFileChange}
          className="hidden"
          id="fileInput"
        />

        {/* Pending uploads */}
        {pendingUploads.length > 0 && (
          <div className="mt-4 w-full max-w-sm">
            <div className="text-xs text-gray-700 mb-2 font-semibold">
              Pending uploads
            </div>
            <ul className="text-xs text-gray-700 text-left space-y-2">
              {pendingUploads.map((p) => (
                <li
                  key={p.id}
                  className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded-md"
                >
                  <span className="truncate max-w-[150px]">{p.file_name}</span>
                  <button
                    onClick={async (e) => {
                      e.stopPropagation();
                      await removePendingUpload(p.id);
                    }}
                    className="text-gray-500 hover:text-red-600 transition"
                    title="Remove pending upload"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </li>
              ))}
            </ul>

            <div className="flex gap-2 mt-3">
              <button
                onClick={async (e) => {
                  e.stopPropagation(); 
                  await handleConfirmPending(); 
                }}
                disabled={isConfirming}
                className="flex-1 bg-black text-white text-sm px-4 py-2 rounded-md hover:bg-black-600"
              >
                {isConfirming ? "Confirming..." : "Confirm"}
              </button>
            </div>

          </div>
        )}
                 </Card>
        {/* <CloudUpload className="w-10 h-10 text-black mb-3" /> */}
        {/* <p className="text-gray-700 text-sm mb-2">
          Drag & drop files here or click to select
        </p> */}
     

      {/* <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <Card style={{ padding: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, border: `2px dashed ${T.accent}30` }}
                 >
                  <Icon name="plus" size={24} color={T.accent} />
                  <span style={{ fontSize: 13, color: T.accentText, fontWeight: 600 }}>Drop files here or click to upload</span>
                  <span style={{ fontSize: 11, color: T.textMuted }}>Contracts, proposals, brand assets</span>
                </Card>
                {[
                  { name: 'BestSeller_Proposal.pdf', size: '245 KB', date: '2026-02-24', type: 'pdf' },
                  { name: 'SocialMedia_Brief.docx', size: '128 KB', date: '2026-02-22', type: 'doc' },
                  { name: 'Brand_Guidelines.pdf', size: '1.2 MB', date: '2026-02-20', type: 'pdf' },
                ].map((f, i) => (
                  <Card key={i} hover style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 8, background: f.type === 'pdf' ? '#ef444412' : '#3b82f612', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Icon name="file" size={16} color={f.type === 'pdf' ? '#ef4444' : '#3b82f6'} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>{f.name}</div>
                      <div style={{ fontSize: 11, color: T.textMuted }}>{f.size} · {f.date}</div>
                    </div>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}><Icon name="eye" size={16} color={T.textMuted} /></button>
                  </Card>
                ))}
              </div> */}

      {/* Confirmed / Uploaded Files */}
      {isLoading ? (
        <p className="text-gray-400 text-sm text-center">Loading files...</p>
      ) : uploaded.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {uploaded.map((file,i) => {
            const isImage = /\.(png|jpg|jpeg|webp|gif)$/i.test(file.file_name);
            const isPDF = /\.pdf$/i.test(file.file_name);
            const isText = /\.(txt|md|csv)$/i.test(file.file_name);
            const isDoc = /\.(docx?|pptx?|xlsx?)$/i.test(file.file_name);

            const getFileIcon = () => {
              if (isPDF)
                return (
                  <span className="bg-red-100 text-red-600 text-xs font-semibold px-2 py-1 rounded">
                    PDF
                  </span>
                );
              if (isDoc)
                return (
                  <span className="bg-blue-100 text-blue-600 text-xs font-semibold px-2 py-1 rounded">
                    DOC
                  </span>
                );
              if (isText)
                return (
                  <span className="bg-amber-100 text-amber-600 text-xs font-semibold px-2 py-1 rounded">
                    TXT
                  </span>
                );
              return (
                <span className="bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-1 rounded">
                  FILE
                </span>
              );
            };

            // const size = file.size ? `${(file.size / 1024).toFixed(1)} KB` : "";

            return (
              // <div
              //   key={file.id}
              //   className="flex items-center justify-between py-3"
              // >
              //   <div className="flex items-center gap-3">
              //     {isImage ? (
              //       <img
              //         src={file.file_url}
              //         alt={file.file_name}
              //         className="w-10 h-10 rounded-md object-cover border"
              //       />
              //     ) : (
              //       getFileIcon()
              //     )}
              //     <div className="flex flex-col">
              //       <a
              //         href={file.file_url}
              //         target="_blank"
              //         rel="noopener noreferrer"
              //         className="text-sm text-black hover:underline truncate max-w-[180px]"
              //       >
              //         {file.file_name}
              //       </a>
              //       {file.created_at && (
              //         <span className="text-xs text-gray-400">
              //           {file.created_at}
              //         </span>
              //       )}
              //     </div>
              //   </div>
              // </div>
               <Card key={i} hover style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 8, background: file?.type === 'pdf' ? '#ef444412' : '#3b82f612', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Icon name="file" size={16} color={file?.type === 'pdf' ? '#ef4444' : '#3b82f6'} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>{file?.file_name}</div>
                      <div style={{marginTop:4, fontSize: 11, color: T.textMuted }}>{file?.file_size || "10KB"} · {file?.uploaded_date}</div>
                    </div>
                    <a href={file?.file_url} target="_blank" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}><Icon name="eye" size={16} color={T.textMuted} /></a>
                  </Card>
            );
          })}
        </div>
      ) : (
        <p className="text-gray-400 text-sm text-center">
          No files uploaded yet.
        </p>
      )}
    </div>
  );
};

export default FilesTab;
